import type { OrganizationState } from '../../types';

export function employeeNamesAsText(item: { employees?: string[] }, o: OrganizationState): string {
  if (item.employees === undefined) {
    return 'Ingen';
  }
  const a = item.employees
    .map((id) => o.employeesById[id])
    .filter((e) => e && !e.deleted)
    .map((e) => e.name)
    .sort();

  if (a.length === 0) {
    return 'Ingen';
  } else {
    return a.join(', ');
  }
}
